/**
 * Runtime configuration loaded from /env-config.json.
 *
 * This file is generated by `scripts/generate-env-config.mjs` from
 * CloudFormation stack outputs before the portal is built.
 *
 * For local development, copy env-config.example.json to
 * portal/env-config.json and fill in the values.
 */

export interface AppConfig {
  userPoolId: string;
  userPoolClientId: string;
  cognitoDomain: string;
  apiGatewayUrl: string;
  idpProviderName: string;
}

let cachedConfig: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cachedConfig) return cachedConfig;

  const response = await fetch("/env-config.json");
  if (!response.ok) {
    throw new Error(
      `Failed to load /env-config.json (${response.status}). ` +
        "Run 'npm run generate-env' to create it from stack outputs."
    );
  }

  cachedConfig = await response.json();
  return cachedConfig!;
}

export function getConfig(): AppConfig {
  if (!cachedConfig) {
    throw new Error("Config not loaded. Call loadConfig() first.");
  }
  return cachedConfig;
}
